import IGlobalState from '@/interfaces/IGlobalState';
import ISettings from '@/interfaces/ISettings';
import { IFeatureCollection } from '@/interfaces/IFeatureCollection';
import { Marker, Map, LayerGroup } from 'leaflet';
import { IParkingData } from '@/interfaces/IParkingData';
import { IParkingZoneData } from '@/interfaces/IParkingZoneData';
import NavigationService from '@/services/NavigationService';
import { IParkingGroupData } from '@/interfaces/IParkingGroupData';
import { IParkingMeterData } from '@/interfaces/IParkingMeterData';
import { Route } from 'vue-router';
import { IWeatherStatus } from '@/interfaces/IWeatherStatus';
import { IModalData } from '@/services/layers/IModalData';
import { IPosts } from '@/interfaces/IPosts';

export default {
  // ogólne mutacje
  flipResizeFont(state: IGlobalState, payload: number): void {
    state.fontSize = payload;
  },
  flipContrastActive(state: IGlobalState): void {
    state.contrast = !state.contrast;
  },
  setCurrentRoute(state: IGlobalState, payload: Route): void{
    state.currentRoute = payload;
  },
  flipDrawerActive(state: IGlobalState): void {
    state.drawerActive = !state.drawerActive;
  },
  updateDrawerActive(state: IGlobalState, payload: boolean): void {
    state.drawerActive = payload;
  },
  flipInfoDrawerActive(state: IGlobalState): void {
    state.infoDrawerActive = !state.infoDrawerActive;
  },
  updateInfoDrawerActive(state: IGlobalState, payload: boolean): void {
    state.infoDrawerActive = payload;
  },
  flipLocationMode(state: IGlobalState): void {
    state.modes.selectLocation = !state.modes.selectLocation;
  },
  endLocationMode(state: IGlobalState): void {
    state.modes.selectLocation = false;
  },
  updatePosition(state: IGlobalState, payload: {lat: number, lng: number}): void {
    state.position.lat = payload.lat;
    state.position.lng = payload.lng;
  },
  updateZoomFactor(state: IGlobalState, payload: number): void {
    state.zoomFactor = payload;
  },
  showOverlay(state: IGlobalState): void {
    state.modes.showOverlay = true;
  },
  hideOverlay(state: IGlobalState): void {
    state.modes.showOverlay = false;
  },
  // dane API
  updateSettings(state: any, payload: any): void {
    // state.mapSettings.settings = payload.settings;
    // state.mapSettings.segmentsConfig = payload.segmentsConfig;
    // override only this state elements which are delivered in API settings
    Object.entries(payload.mapConfiguration).forEach((item: any) => {
      const key = item[0];
      const value = item[1];
      state.mapSettings.mapConfiguration[key] = value;
    });
  },
  updateSegmentsConfig(state: IGlobalState, payload: any): void {
    state.mapSettings.segmentsConfig = payload;
  },
  updateVisibilityOfModules(state: IGlobalState, payload: any): void {
    // override only this state elements which are delivered in API
    state.mapSettings.settings = {
      ...state.mapSettings.settings, // Spread the original settings
      ...payload.settings, // Overwrite general settings
      visibilityOfModules: {
        ...state.mapSettings.settings.visibilityOfModules, // Spread original visibilityOfModules
        ...payload.settings.visibilityOfModules, // Overwrite specific visibility settings
      },
    };
  },
  updateParkings(state: IGlobalState, payload: IFeatureCollection): void {
    state.parkings = payload;
  },
  updateParkingZones(state: IGlobalState, payload: IFeatureCollection): void {
    state.parkingZones = payload;
  },
  updateParkingMeters(state: IGlobalState, payload: IFeatureCollection): void {
    state.parkingMeters = payload;
  },
  updateParkingSpots(state: IGlobalState, payload: IFeatureCollection): void {
    state.parkingSpots = payload;
  },
  updateParkingGroups(state: IGlobalState, payload: IFeatureCollection): void {
    state.parkingGroups = payload;
  },
  updateEvents(state: IGlobalState, payload: IFeatureCollection): void {
    state.events = payload;
  },
  updateWeatherStations(state: IGlobalState, payload: IFeatureCollection): void {
    state.weatherStations = payload;
  },
  updateCurrentWeather(state: IGlobalState, payload: IWeatherStatus): void {
    state.currentWeather = payload;
  },
  // dane warstw
  updateUserPositionMarker(state: IGlobalState, payload: Marker): void {
    state.userPositionMarker = payload;
  },
  updateLeafletMapInstance(state: IGlobalState, payload: Map): void {
    state.leafletMapInstance = payload;
  },
  updateParkingsLayerGroup(state: IGlobalState, payload: LayerGroup): void {
    state.leafletLayers.parkingLayer = payload;
  },
  updateParkingZonesLayerGroup(state: IGlobalState, payload: LayerGroup): void {
    state.leafletLayers.parkingZones = payload;
  },
  updateParkingZonesMarkersLayerGroup(state: IGlobalState, payload: LayerGroup): void {
    state.leafletLayers.parkingZonesMarkers = payload;
  },
  updateParkingMetersLayerGroup(state: IGlobalState, payload: LayerGroup): void {
    state.leafletLayers.parkingMeters = payload;
  },
  updateParkingSpotsLayerGroup(state: IGlobalState, payload: LayerGroup): void {
    state.leafletLayers.parkingSpots = payload;
  },
  updateParkingGroupsLayerGroup(state: IGlobalState, payload: LayerGroup): void {
    state.leafletLayers.parkingGroups = payload;
  },
  updateEventsAccidentsLayerGroup(state: IGlobalState, payload: LayerGroup): void {
    state.leafletLayers.eventsAccidents = payload;
  },
  updateEventsBuildingLayerGroup(state: IGlobalState, payload: LayerGroup): void {
    state.leafletLayers.eventsBuilding = payload;
  },
  updateEventsBlocksLayerGroup(state: IGlobalState, payload: LayerGroup): void {
    state.leafletLayers.eventsBlocks = payload;
  },
  updateEventsHazardLayerGroup(state: IGlobalState, payload: LayerGroup): void {
    state.leafletLayers.eventsHazard = payload;
  },
  updateWeatherStationsLayerGroup(state: IGlobalState, payload: LayerGroup): void {
    state.leafletLayers.weatherStations = payload;
  },
  updatePosts(state: IGlobalState, payload: IPosts): void {
    state.posts = payload;
  },
  // obsługa modali
  displayModal(state: IGlobalState, payload: IModalData) {
    state.modal.data = payload;
    state.modal.display = true;
  },
  closeModal(state: IGlobalState) {
    state.modal.display = false;
  },
  // flagi wyświetlania warstw
  enableParkingsLayer(state: IGlobalState): void {
    state.mapSettings.mapConfiguration.parkings = true;
  },
  disableParkingsLayer(state: IGlobalState): void {
    state.mapSettings.mapConfiguration.parkings = false;
  },
  enableParkingZonesLayer(state: IGlobalState): void {
    state.mapSettings.mapConfiguration.parkingZone = true;
  },
  disableParkingZonesLayer(state: IGlobalState): void {
    state.mapSettings.mapConfiguration.parkingZone = false;
  },
  enableParkingMetersLayer(state: IGlobalState): void {
    state.mapSettings.mapConfiguration.parkingMeters = true;
  },
  disableParkingMetersLayer(state: IGlobalState): void {
    state.mapSettings.mapConfiguration.parkingMeters = false;
  },
  enableParkingSpotsLayer(state: IGlobalState): void {
    state.mapSettings.mapConfiguration.parkingSpots = true;
  },
  disableParkingSpotsLayer(state: IGlobalState): void {
    state.mapSettings.mapConfiguration.parkingSpots = false;
  },
  enableParkingGroupsLayer(state: IGlobalState): void {
    state.mapSettings.mapConfiguration.parkingGroups = true;
  },
  disableParkingGroupsLayer(state: IGlobalState): void {
    state.mapSettings.mapConfiguration.parkingGroups = false;
  },
  enableEventsLayer(state: IGlobalState): void {
    state.mapSettings.mapConfiguration.events = true;
  },
  disableEventsLayer(state: IGlobalState): void {
    state.mapSettings.mapConfiguration.events = false;
  },
  enableEventsAccidentsLayer(state: IGlobalState): void {
    state.mapSettings.mapConfiguration.accident = true;
  },
  disableEventsAccidentsLayer(state: IGlobalState): void {
    state.mapSettings.mapConfiguration.accident = false;
  },
  enableEventsBuildingLayer(state: IGlobalState): void {
    state.mapSettings.mapConfiguration.constructions = true;
  },
  disableEventsBuildingLayer(state: IGlobalState): void {
    state.mapSettings.mapConfiguration.constructions = false;
  },
  enableEventsBlocksLayer(state: IGlobalState): void {
    state.mapSettings.mapConfiguration.roadClosed = true;
  },
  disableEventsBlocksLayer(state: IGlobalState): void {
    state.mapSettings.mapConfiguration.roadClosed = false;
  },
  enableEventsHazardLayer(state: IGlobalState): void {
    state.mapSettings.mapConfiguration.hazard = true;
  },
  disableEventsHazardLayer(state: IGlobalState): void {
    state.mapSettings.mapConfiguration.hazard = false;
  },
  enableWeatherStationsLayer(state: IGlobalState): void {
    state.mapSettings.mapConfiguration.weatherStations = true;
  },
  disableWeatherStationsLayer(state: IGlobalState): void {
    state.mapSettings.mapConfiguration.weatherStations = false;
  },
};
